import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import StakingPower from "./components/StakingPower";
import Utilities from "./components/Utilities";
import Roadmap from "./components/Roadmap";
import Changelog from "./components/Changelog";
import Suggestions from "./components/Suggestions";
import Community from "./components/Community";
import Partners from "./components/Partners";
import Contest from "./components/Contest";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
  return (
    <div className="relative min-h-screen bg-[#0b0b0f] overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 -z-10 bg-animated" />
      
      {/* Scroll progress indicator */}
      <ScrollProgressIndicator />

      {/* Content stack */}
      <Header />
      <main className="pt-16">
        <Hero />
        <Stats />
        <StakingPower />
        <Utilities />
        <Roadmap />
        <Changelog />
        <Contest />
        <Suggestions />
        <Community />
        <Partners />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

// Scroll progress indicator at top
function ScrollProgressIndicator() {
  const [scrollProgress, setScrollProgress] = React.useState(0);

  React.useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const progress = (scrollTop / scrollHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 h-1 bg-black/20 z-50">
      <div
        className="h-full bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 transition-all duration-150 ease-out"
        style={{ width: `${scrollProgress}%` }}
      />
    </div>
  );
}
